import { EnumUtils } from '@colonist/utils';
import * as gameBaseTypes from '@colonist/game-base-types';
import { GAME_STATE_UPDATE_ENUM_ID, SOCKET_EVENT_ID } from '@colonist/types';
(function(NetworkEnums) {
    (function(State) {
        State[State["GameStateUpdate"] = GAME_STATE_UPDATE_ENUM_ID] = "GameStateUpdate";
        State[State["MatchmakingStateUpdate"] = 131] = "MatchmakingStateUpdate";
        State[State["LobbyStateUpdate"] = 133] = "LobbyStateUpdate";
        State[State["ChannelStateUpdate"] = 134] = "ChannelStateUpdate";
        State[State["GeneralStateUpdate"] = 135] = "GeneralStateUpdate";
        State[State["SocketMonitorUpdate"] = 136] = "SocketMonitorUpdate";
        State[State["RoomEvent"] = 137] = "RoomEvent";
        State[State["SocketEvent"] = SOCKET_EVENT_ID] = "SocketEvent";
        State[State["ShuffleStateUpdate"] = 139] = "ShuffleStateUpdate";
    })(NetworkEnums.State || (NetworkEnums.State = {}));
    (function(ShuffleState) {
        ShuffleState[ShuffleState["ShuffleQueueData"] = 1] = "ShuffleQueueData";
        ShuffleState[ShuffleState["ShufflePlayerData"] = 2] = "ShufflePlayerData";
    })(NetworkEnums.ShuffleState || (NetworkEnums.ShuffleState = {}));
    (function(GeneralState) {
        GeneralState[GeneralState["UpdateOnlineStatus"] = 1] = "UpdateOnlineStatus";
        GeneralState[GeneralState["ReceivedRoomInvites"] = 2] = "ReceivedRoomInvites";
        GeneralState[GeneralState["RoomInviteResponse"] = 3] = "RoomInviteResponse";
        GeneralState[GeneralState["RemoveRoomInvite"] = 4] = "RemoveRoomInvite";
        GeneralState[GeneralState["RoomInviteSentSuccessfully"] = 5] = "RoomInviteSentSuccessfully";
        GeneralState[GeneralState["Notifications"] = 6] = "Notifications";
        GeneralState[GeneralState["MarkedAsRead"] = 7] = "MarkedAsRead";
        GeneralState[GeneralState["ReceivedFriendRequest"] = 8] = "ReceivedFriendRequest";
    })(NetworkEnums.GeneralState || (NetworkEnums.GeneralState = {}));
    (function(LobbyState) {
        LobbyState[LobbyState["AutoRejoinGame"] = 1] = "AutoRejoinGame";
        LobbyState[LobbyState["SessionState"] = 2] = "SessionState";
        LobbyState[LobbyState["UserStateUpdate"] = 3] = "UserStateUpdate";
        LobbyState[LobbyState["LobbyDisconnectData"] = 4] = "LobbyDisconnectData";
        LobbyState[LobbyState["SendPopup"] = 5] = "SendPopup";
        LobbyState[LobbyState["ShowCornerPopup"] = 6] = "ShowCornerPopup";
        LobbyState[LobbyState["SendBroadcast"] = 7] = "SendBroadcast";
        LobbyState[LobbyState["SocketTest"] = 8] = "SocketTest";
        LobbyState[LobbyState["ServerUpdating"] = 9] = "ServerUpdating";
        LobbyState[LobbyState["ReloadClient"] = 10] = "ReloadClient";
        LobbyState[LobbyState["ServerUpdated"] = 11] = "ServerUpdated";
        LobbyState[LobbyState["RoomListUpdate"] = 12] = "RoomListUpdate";
        LobbyState[LobbyState["ItemPurchaseSuccessPopup"] = 13] = "ItemPurchaseSuccessPopup";
    })(NetworkEnums.LobbyState || (NetworkEnums.LobbyState = {}));
    (function(ChannelState) {
        ChannelState[ChannelState["ChannelRoomUpdate"] = 1] = "ChannelRoomUpdate";
    })(NetworkEnums.ChannelState || (NetworkEnums.ChannelState = {}));
})(NetworkEnums || (NetworkEnums = {}));
(function(GameStateEnums) {
    (function(UIGameEventEnums) {
        UIGameEventEnums[UIGameEventEnums["FinishedBuildingGame"] = 0] = "FinishedBuildingGame";
        UIGameEventEnums[UIGameEventEnums["GameStateUpdated"] = 1] = "GameStateUpdated";
        UIGameEventEnums[UIGameEventEnums["PlayerControllerStateUpdated"] = 2] = "PlayerControllerStateUpdated";
        UIGameEventEnums[UIGameEventEnums["DiceStateUpdated"] = 3] = "DiceStateUpdated";
        UIGameEventEnums[UIGameEventEnums["BankStateUpdated"] = 4] = "BankStateUpdated";
        UIGameEventEnums[UIGameEventEnums["BankTradeRatioStateUpdated"] = 5] = "BankTradeRatioStateUpdated";
        UIGameEventEnums[UIGameEventEnums["MapStateUpdated"] = 6] = "MapStateUpdated";
        UIGameEventEnums[UIGameEventEnums["KarmaUpdated"] = 7] = "KarmaUpdated";
        UIGameEventEnums[UIGameEventEnums["CanResign"] = 8] = "CanResign";
        UIGameEventEnums[UIGameEventEnums["AmountOfCardsToDiscardUpdated"] = 9] = "AmountOfCardsToDiscardUpdated";
        UIGameEventEnums[UIGameEventEnums["AmountOfCardsToSelect"] = 10] = "AmountOfCardsToSelect";
        UIGameEventEnums[UIGameEventEnums["SelectCardsToDiscard"] = 11] = "SelectCardsToDiscard";
        UIGameEventEnums[UIGameEventEnums["SelectCardsFromBankUsingDevelopmentCard"] = 12] = "SelectCardsFromBankUsingDevelopmentCard";
        UIGameEventEnums[UIGameEventEnums["SelectCardsForPendingDistribution"] = 13] = "SelectCardsForPendingDistribution";
        UIGameEventEnums[UIGameEventEnums["SelectCardToGiveToAnotherPlayer"] = 14] = "SelectCardToGiveToAnotherPlayer";
        UIGameEventEnums[UIGameEventEnums["ConfirmUseDevelopmentCard"] = 15] = "ConfirmUseDevelopmentCard";
        UIGameEventEnums[UIGameEventEnums["StealDevelopmentCardFromPlayer"] = 16] = "StealDevelopmentCardFromPlayer";
        UIGameEventEnums[UIGameEventEnums["StealResourceCardFromPlayer"] = 17] = "StealResourceCardFromPlayer";
        UIGameEventEnums[UIGameEventEnums["SelectPlayer"] = 18] = "SelectPlayer";
        UIGameEventEnums[UIGameEventEnums["SelectPlayerForDevelopmentCard"] = 19] = "SelectPlayerForDevelopmentCard";
        UIGameEventEnums[UIGameEventEnums["SelectPlayerAndCard"] = 20] = "SelectPlayerAndCard";
        UIGameEventEnums[UIGameEventEnums["SelectDice"] = 21] = "SelectDice";
        UIGameEventEnums[UIGameEventEnums["GivePlayerCardFromTile"] = 22] = "GivePlayerCardFromTile";
        UIGameEventEnums[UIGameEventEnums["ExchangeCards"] = 23] = "ExchangeCards";
        UIGameEventEnums[UIGameEventEnums["GivePlayerGrantedCards"] = 24] = "GivePlayerGrantedCards";
        UIGameEventEnums[UIGameEventEnums["CloseTradeUI"] = 25] = "CloseTradeUI";
        UIGameEventEnums[UIGameEventEnums["ShowTradeUI"] = 26] = "ShowTradeUI";
        UIGameEventEnums[UIGameEventEnums["TradeStateUpdated"] = 27] = "TradeStateUpdated";
        UIGameEventEnums[UIGameEventEnums["EmbargoStatusUpdated"] = 28] = "EmbargoStatusUpdated";
        UIGameEventEnums[UIGameEventEnums["RemoveTradeOffer"] = 29] = "RemoveTradeOffer";
        UIGameEventEnums[UIGameEventEnums["TradeResetStateAtEndOfTurn"] = 30] = "TradeResetStateAtEndOfTurn";
        UIGameEventEnums[UIGameEventEnums["TradeResponseState"] = 31] = "TradeResponseState";
        UIGameEventEnums[UIGameEventEnums["NewTradeOfferReceived"] = 32] = "NewTradeOfferReceived";
        UIGameEventEnums[UIGameEventEnums["TradePlayersCreatingCounterOfferState"] = 33] = "TradePlayersCreatingCounterOfferState";
        UIGameEventEnums[UIGameEventEnums["BoldTextInTradeWindow"] = 34] = "BoldTextInTradeWindow";
        UIGameEventEnums[UIGameEventEnums["CloseDiscardCardUI"] = 35] = "CloseDiscardCardUI";
        UIGameEventEnums[UIGameEventEnums["ShowDiscardCardUI"] = 36] = "ShowDiscardCardUI";
        UIGameEventEnums[UIGameEventEnums["ClosePopupUI"] = 37] = "ClosePopupUI";
        UIGameEventEnums[UIGameEventEnums["SpecialBuildPhaseStateUpdated"] = 38] = "SpecialBuildPhaseStateUpdated";
        UIGameEventEnums[UIGameEventEnums["SetRoadEdgeHighlight"] = 39] = "SetRoadEdgeHighlight";
        UIGameEventEnums[UIGameEventEnums["SetShipEdgeHighlight"] = 40] = "SetShipEdgeHighlight";
        UIGameEventEnums[UIGameEventEnums["SetCornerHighlight"] = 41] = "SetCornerHighlight";
        UIGameEventEnums[UIGameEventEnums["SetTileHighlight"] = 42] = "SetTileHighlight";
        UIGameEventEnums[UIGameEventEnums["HighlightDiceNumbersForInventor"] = 43] = "HighlightDiceNumbersForInventor";
        UIGameEventEnums[UIGameEventEnums["VoteReceived"] = 44] = "VoteReceived";
        UIGameEventEnums[UIGameEventEnums["PlayerReceivedAchievement"] = 45] = "PlayerReceivedAchievement";
        UIGameEventEnums[UIGameEventEnums["CanvasResized"] = 46] = "CanvasResized";
        UIGameEventEnums[UIGameEventEnums["ClickedMultiButton"] = 47] = "ClickedMultiButton";
        UIGameEventEnums[UIGameEventEnums["SpectatorDataUpdated"] = 48] = "SpectatorDataUpdated";
        UIGameEventEnums[UIGameEventEnums["KnightStateUpdated"] = 49] = "KnightStateUpdated";
        UIGameEventEnums[UIGameEventEnums["CityImprovementStateReceived"] = 50] = "CityImprovementStateReceived";
        UIGameEventEnums[UIGameEventEnums["CityImprovementStateUpdated"] = 51] = "CityImprovementStateUpdated";
        UIGameEventEnums[UIGameEventEnums["ForceShowCityImprovementButtons"] = 52] = "ForceShowCityImprovementButtons";
        UIGameEventEnums[UIGameEventEnums["MerchantStateUpdated"] = 53] = "MerchantStateUpdated";
        UIGameEventEnums[UIGameEventEnums["GameEnd"] = 54] = "GameEnd";
        UIGameEventEnums[UIGameEventEnums["GameEndRematchTextUpdated"] = 55] = "GameEndRematchTextUpdated";
        UIGameEventEnums[UIGameEventEnums["RobberMoved"] = 56] = "RobberMoved";
        UIGameEventEnums[UIGameEventEnums["MerchantBankTradeRatioActive"] = 57] = "MerchantBankTradeRatioActive";
        UIGameEventEnums[UIGameEventEnums["GamePauseToggled"] = 58] = "GamePauseToggled";
        UIGameEventEnums[UIGameEventEnums["NewChatMessageReceived"] = 59] = "NewChatMessageReceived";
        UIGameEventEnums[UIGameEventEnums["TemporaryPlayerStuckInEmbargoState"] = 60] = "TemporaryPlayerStuckInEmbargoState";
        UIGameEventEnums[UIGameEventEnums["BeginnerHintReceived"] = 61] = "BeginnerHintReceived";
        UIGameEventEnums[UIGameEventEnums["HighlightTradeOffer"] = 62] = "HighlightTradeOffer";
        UIGameEventEnums[UIGameEventEnums["PopupActive"] = 63] = "PopupActive";
        UIGameEventEnums[UIGameEventEnums["FeedbackFormSubmitted"] = 64] = "FeedbackFormSubmitted";
        UIGameEventEnums[UIGameEventEnums["FloatingNotification"] = 65] = "FloatingNotification";
        UIGameEventEnums[UIGameEventEnums["BeginnerModeStart"] = 66] = "BeginnerModeStart";
        UIGameEventEnums[UIGameEventEnums["BeginnerModeInteractWithGuide"] = 67] = "BeginnerModeInteractWithGuide";
        UIGameEventEnums[UIGameEventEnums["BeginnerModeForceOpenGuideBubble"] = 68] = "BeginnerModeForceOpenGuideBubble";
        UIGameEventEnums[UIGameEventEnums["BeginnerModeActionUpdated"] = 69] = "BeginnerModeActionUpdated";
        UIGameEventEnums[UIGameEventEnums["BeginnerModeLevelEnd"] = 70] = "BeginnerModeLevelEnd";
        UIGameEventEnums[UIGameEventEnums["GameInformationPopupActive"] = 71] = "GameInformationPopupActive";
        UIGameEventEnums[UIGameEventEnums["BeginnerModeClickedDisabledElement"] = 72] = "BeginnerModeClickedDisabledElement";
        UIGameEventEnums[UIGameEventEnums["SuggestAction"] = 73] = "SuggestAction";
        UIGameEventEnums[UIGameEventEnums["SelectDiceNumbersConfirmation"] = 74] = "SelectDiceNumbersConfirmation";
        UIGameEventEnums[UIGameEventEnums["DiceNumberAnimationEnd"] = 75] = "DiceNumberAnimationEnd";
        UIGameEventEnums[UIGameEventEnums["TileNumberAnimationEnd"] = 76] = "TileNumberAnimationEnd";
        UIGameEventEnums[UIGameEventEnums["CardAnimationEnd"] = 77] = "CardAnimationEnd";
        UIGameEventEnums[UIGameEventEnums["ClientReconnectionTriggered"] = 78] = "ClientReconnectionTriggered";
        // GameVisibilityUpdated tracks when a user is actively engaged in the game
        // Web: Triggers when user switches tabs
        // Mobile: Triggers when user moves app to background
        // Discord: Triggers when user moves activity to background
        UIGameEventEnums[UIGameEventEnums["GameVisibilityUpdated"] = 79] = "GameVisibilityUpdated";
    })(GameStateEnums.UIGameEventEnums || (GameStateEnums.UIGameEventEnums = {}));
})(GameStateEnums || (GameStateEnums = {}));
/**
 * @deprecated Import GameTypeEnum from @colonist/game-base-types
 */ export const GameTypeEnum = gameBaseTypes.GameTypeEnum;
/**
 * @deprecated Import ModeSettingEnum from @colonist/game-base-types
 */ export const ModeSettingEnum = gameBaseTypes.ModeSettingEnum;
export var RankedModeTypes = /*#__PURE__*/ function(RankedModeTypes) {
    RankedModeTypes[RankedModeTypes["Classic4P"] = 0] = "Classic4P";
    RankedModeTypes[RankedModeTypes["Classic1v1"] = 1] = "Classic1v1";
    RankedModeTypes[RankedModeTypes["Seafarerers4P"] = 2] = "Seafarerers4P";
    RankedModeTypes[RankedModeTypes["CitiesAndKnights4P"] = 3] = "CitiesAndKnights4P";
    RankedModeTypes[RankedModeTypes["Rush4P"] = 4] = "Rush4P";
    return RankedModeTypes;
}({});
/**
 * @deprecated Import ELOTypeEnum from @colonist/game-base-types
 */ export const ELOTypeEnum = gameBaseTypes.ELOTypeEnum;
export var RankedSeasonTypes = /*#__PURE__*/ function(RankedSeasonTypes) {
    RankedSeasonTypes[RankedSeasonTypes["Development"] = 0] = "Development";
    RankedSeasonTypes[RankedSeasonTypes["Alpha"] = 1] = "Alpha";
    RankedSeasonTypes[RankedSeasonTypes["Beta1"] = 2] = "Beta1";
    RankedSeasonTypes[RankedSeasonTypes["Beta2"] = 3] = "Beta2";
    RankedSeasonTypes[RankedSeasonTypes["Season1"] = 4] = "Season1";
    RankedSeasonTypes[RankedSeasonTypes["Season2"] = 5] = "Season2";
    RankedSeasonTypes[RankedSeasonTypes["Season3"] = 6] = "Season3";
    RankedSeasonTypes[RankedSeasonTypes["Season4"] = 7] = "Season4";
    RankedSeasonTypes[RankedSeasonTypes["Season5"] = 8] = "Season5";
    RankedSeasonTypes[RankedSeasonTypes["Season6"] = 9] = "Season6";
    RankedSeasonTypes[RankedSeasonTypes["Season7"] = 10] = "Season7";
    RankedSeasonTypes[RankedSeasonTypes["Season8"] = 11] = "Season8";
    RankedSeasonTypes[RankedSeasonTypes["Season9"] = 12] = "Season9";
    RankedSeasonTypes[RankedSeasonTypes["Season10"] = 13] = "Season10";
    RankedSeasonTypes[RankedSeasonTypes["Season11"] = 14] = "Season11";
    RankedSeasonTypes[RankedSeasonTypes["Season12"] = 15] = "Season12";
    RankedSeasonTypes[RankedSeasonTypes["Season13"] = 16] = "Season13";
    RankedSeasonTypes[RankedSeasonTypes["Season14"] = 17] = "Season14";
    RankedSeasonTypes[RankedSeasonTypes["Season15"] = 18] = "Season15";
    RankedSeasonTypes[RankedSeasonTypes["Season16"] = 19] = "Season16";
    RankedSeasonTypes[RankedSeasonTypes["Season17"] = 20] = "Season17";
    return RankedSeasonTypes;
}({});
/**
 * @deprecated Import ExtensionSettingEnum from @colonist/game-base-types
 */ export const ExtensionSettingEnum = gameBaseTypes.ExtensionSettingEnum;
export function getExtensionSettingText(extensionSetting) {
    const extensionSettingKey = EnumUtils.getEnumKey(extensionSetting, ExtensionSettingEnum);
    return {
        key: `strings:game.settings.gameInfoTab.extension.options.${extensionSettingKey}`
    };
}
/**
 * @deprecated Import ExtensionSettingEnum from @colonist/game-base-types
 */ export const ScenarioSettingEnum = gameBaseTypes.ScenarioSettingEnum;
export function getScenarioSettingText(scenarioSetting) {
    const scenarioSettingKey = EnumUtils.getEnumKey(scenarioSetting, ScenarioSettingEnum);
    return {
        key: `strings:colonistCommon.gameMaps.seafarers.scenarios.${scenarioSettingKey}`
    };
}
/**
 * @deprecated Import MapSettingEnum from @colonist/game-base-types
 */ export const MapSettingEnum = gameBaseTypes.MapSettingEnum;
/**
 * @deprecated Import DiceSettingEnum from @colonist/game-base-types
 */ export const DiceSettingEnum = gameBaseTypes.DiceSettingEnum;
import { GAME_TIMER_OPTIONS } from '@colonist/shared-types';
export function getDiceSettingText(diceSetting) {
    switch(diceSetting){
        case DiceSettingEnum.Balanced:
            return {
                key: `strings:colonistCommon.DiceSettingEnum.Balanced`
            };
        case DiceSettingEnum.Random:
            return {
                key: `strings:colonistCommon.DiceSettingEnum.Random`
            };
        case DiceSettingEnum.PredefinedDiceSequenceDeleted:
            return {
                key: `strings:colonistCommon.utils.bug`
            };
        case DiceSettingEnum.StressTestSequence:
            return {
                key: `strings:colonistCommon.utils.bug`
            };
    }
}
export var RankedConstants = /*#__PURE__*/ function(RankedConstants) {
    RankedConstants[RankedConstants["NumberOfGamesToUnlockRanked"] = 5] = "NumberOfGamesToUnlockRanked";
    return RankedConstants;
}({});
(function(PlayerEnums) {
    /**
     * @deprecated Import GameSpeedSettings from @colonist/game-base-types
     */ PlayerEnums.GameSpeedSettings = gameBaseTypes.GameSpeedSettings;
    function getSpeedSettingText(gameSpeedSetting) {
        const allGameSpeedSettings = GAME_TIMER_OPTIONS;
        const option = allGameSpeedSettings[gameSpeedSetting];
        return {
            key: option.labelTranslationKey
        };
    }
    PlayerEnums.getSpeedSettingText = getSpeedSettingText;
    (function(RoomJoinStatus) {
        RoomJoinStatus[RoomJoinStatus["Joined"] = 0] = "Joined";
        RoomJoinStatus[RoomJoinStatus["CannotJoinKicked"] = 1] = "CannotJoinKicked";
        RoomJoinStatus[RoomJoinStatus["CannotJoinFull"] = 2] = "CannotJoinFull";
        RoomJoinStatus[RoomJoinStatus["CannotJoinKarma"] = 3] = "CannotJoinKarma";
    })(PlayerEnums.RoomJoinStatus || (PlayerEnums.RoomJoinStatus = {}));
    (function(ChannelStatus) {
        ChannelStatus[ChannelStatus["Game"] = 0] = "Game";
        ChannelStatus[ChannelStatus["Room"] = 1] = "Room";
        ChannelStatus[ChannelStatus["Closed"] = 2] = "Closed";
        ChannelStatus[ChannelStatus["Reconnect"] = 3] = "Reconnect";
    })(PlayerEnums.ChannelStatus || (PlayerEnums.ChannelStatus = {}));
    (function(RoomInfoMessage) {
        RoomInfoMessage[RoomInfoMessage["None"] = 0] = "None";
        RoomInfoMessage[RoomInfoMessage["ClickReady"] = 1] = "ClickReady";
        RoomInfoMessage[RoomInfoMessage["PremiumItemSelected"] = 2] = "PremiumItemSelected";
    })(PlayerEnums.RoomInfoMessage || (PlayerEnums.RoomInfoMessage = {}));
})(PlayerEnums || (PlayerEnums = {}));
export var NetworkEnums, GameStateEnums, PlayerEnums;
